import { render, staticRenderFns } from "./ButtonSendEmail.vue?vue&type=template&id=3f9ec2c2&"
import script from "./ButtonSendEmail.vue?vue&type=script&lang=ts&"
export * from "./ButtonSendEmail.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonSendEmail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports